exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/zhaolinxu/GitHub/IdleAnt/src/app/ui/ui.component.scss
// module id = ../../../../../src/app/ui/ui.component.scss
// module chunks = 1